export interface PaginatedLinksDocumented {
  first: string;
  previous: string;
  current: string;
  next: string;
  last: string;
}

export type Meta = {
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  totalPages: number;
  sortBy: Array<[string, string]>;
  filter: {
    tvl_usd?: string;
    volume_24h_usd?: string;
  };
};

export interface PaginatedMetaDocumented<T> {
  data: T[];
  meta: {
    itemsPerPage: number;
    totalItems: number;
    currentPage: number;
    totalPages: number;
    sortBy: {
      [key: string]: "asc" | "desc";
    };
  };
  searchBy: (keyof T)[];
  search: string;
}

export interface ChartData {
  count: string;
  series: string;
}

export interface ChartDataValue {
  value: string;
  date: string;

  count?: string;
  series?: string;
};

export enum SortBy {
  TVL = 'tvl_usd',
  NUMBER = 'number',
  VOLUME_24 = 'volume_24h_usd',
}

export enum SortingOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum LimitsKeys {
  GTE = '$gte',
  LTE = '$lte',
}